import { ICareerUpdatePayload } from './space.model';

export class CreateCareer {
  static readonly type = '[space] CreateCareer';
  constructor(public careerUpdatePayload: ICareerUpdatePayload) {}
}

export class UpdateCareer {
  static readonly type = '[space] UpdateCareer';
  constructor(public careerUpdatePayload: ICareerUpdatePayload) {}
}

export class UpdateMemberCareer {
  static readonly type = '[space] UpdateMemberCareer';
  constructor(public careerIds: number[], public userId: number) {}
}

export class UpdateUserName {
  static readonly type = '[space] UpdateUserName';
  constructor(
    public userId: number,
    public fullname: string,
    public username?: string,
    public alias?: string
  ) {}
}

export class DeleteCareer {
  static readonly type = '[space] DeleteCareer';
  constructor(public careerId: number, public workSpaceId: number) {}
}

export class FetchCareers {
  static readonly type = '[space] FetchCareers';
  constructor(public workSpaceId: number) {}
}

export class SearchUser {
  static readonly type = '[space] SearchUser';
  constructor(public email: string, public subscriptionMembers: any) {}
}

export class AddMember {
  static readonly type = '[space] AddMember';
  constructor(public subscriptionid: string, public member: any) {}
}

export class FetchWorkSpace {
  static readonly type = '[space] FetchWorkSpace';
  constructor() {}
}

export class FetchProgressCareer {
  static readonly type = '[space] FetchProgressCareer';
  constructor(
    public uid: number,
    public subscriptionMemberId: number,
    public workspaceId: number
  ) {}
}

export class FetchProgressCourse {
  static readonly type = '[space] FetchProgressCourse';
  constructor(public uid: number, public careerId: number) {}
}
